// extracted by mini-css-extract-plugin
export default {"container_form":"styles_container_form__HM0+I","content_form":"styles_content_form__0Qacp","double_input":"styles_double_input__skzTM","doubleInput":"styles_doubleInput__0rIhJ"};